export const toCamelCase = origObj => {
    if(!origObj) return origObj

    return Object.keys(origObj).reduce((newObj, key) => {
        const val = origObj[key];
        newObj[key.charAt(0).toLowerCase() + key.slice(1)] = (typeof val === 'object') ? toCamelCase(val) : val;
        return newObj;
    }, {});
}